import { Container } from "@amzn/ask-legal-domain";

const getContainerTypeDisplayName = (containerType: Container.Type): string => {
    if (containerType === "ADVANCED_LIST") {
        return "Smart Table";
    }

    if (containerType === "WHOS_MY_LAWYER") {
        return "Who's My Legal Contact";
    }

    return containerType
        .split("_")
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
};

/**
 * Generates a header for Add/Edit container modals
 * @param action The action performed ('Add' or 'Edit')
 * @param containerType The container type
 * @returns Formatted header string
 */
export const getContainerHeader = (action: "Add" | "Edit", containerType: Container.Type): string => {
    const displayName = getContainerTypeDisplayName(containerType);

    if (action === "Add") {
        return `Add ${displayName} Container`;
    } else {
        return `Edit ${displayName} Container`;
    }
};
